/**
 * Reactive Zustand store for undo/redo state.
 *
 * The MCP undo middleware notifies this store after every stack mutation
 * via syncUndoState(). React components subscribe via useUndoStateStore
 * and get automatic re-renders when canUndo/canRedo changes.
 */

import { createStore, useStore } from 'zustand'

interface UndoReactiveState {
  canUndo: boolean
  canRedo: boolean
}

export const undoStateStore = createStore<UndoReactiveState>()(() => ({
  canUndo: false,
  canRedo: false,
}))

/** React hook — subscribes to reactive undo state. */
export function useUndoStateStore<T>(selector: (s: UndoReactiveState) => T): T {
  return useStore(undoStateStore, selector)
}

/** Synchronize undo state from MCP middleware into the reactive store. */
export function syncUndoState(state: { canUndo: boolean; canRedo: boolean }): void {
  undoStateStore.setState(state)
}
